import * as Yup from "yup";
import form from "./form";

const {
  formField: { firstname, lastname, email, password, repeatPassword },
} = form;

export const signInValidations = Yup.object().shape({
  [email.name]: Yup.string().email("Must be a valid email").required("Email is required"),
  [password.name]: Yup.string().required("Password is required"),
});

export const askValidations = Yup.object().shape({
  [firstname.name]: Yup.string().required("First name is required"),
  [lastname.name]: Yup.string().required("Last name is required"),
  [email.name]: Yup.string().email("Must be a valid email").required("Email is required"),
  [password.name]: Yup.string()
    .required("Password is required")
    .min(8, "Your password should be more than 8 characters.")
    .matches(/[a-z]/, "Your password must contain at least one lowercase letter.")
    .matches(/[A-Z]/, "Your password must contain at least one uppercase letter.")
    .matches(/\d/, "Your password must contain at least one number.")
    .matches(/[^A-Za-z0-9]/, "Your password must contain at least one special character."),
  [repeatPassword.name]: Yup.string()
    .required("Please confirm your password")
    .oneOf([Yup.ref("password"), null], "Your password doesn't match."),
});
